import * as React from 'react';

interface Props {
  className?: string;
  active?: boolean;
  activeColor?: string;
  inactiveColor?: string;
}

export class DesktopSVG extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { active, activeColor = '#1c1c1c', inactiveColor = '#b9b9b9' } = this.props;
    return (
      <svg width="28" height="22" viewBox="0 0 28 22" xmlns="http://www.w3.org/2000/svg">
        <g fill={active ? activeColor : inactiveColor} fillRule="evenodd">
          <path d="M11 18h1v4h-1z" />
          <path d="M9 21h10v1H9z" />
          <path d="M16 18h1v4h-1z" />
          <path d="M1 3v13c0 1.11.891 2 1.996 2h22.008A2.004 2.004 0 0 0 27 16V3c0-1.11-.891-2-1.996-2H2.996A2.004 2.004 0 0 0 1 3zM0 3c0-1.657 1.35-3 2.996-3h22.008A2.994 2.994 0 0 1 28 3v13c0 1.657-1.35 3-2.996 3H2.996A2.994 2.994 0 0 1 0 16V3z" />
        </g>
      </svg>
    );
  }
}
